import { Box } from "@twilio-paste/core/box";
import { ChevronDownIcon } from "@twilio-paste/icons/esm/ChevronDownIcon";
import { ChatIcon } from "@twilio-paste/icons/esm/ChatIcon";
import { useDispatch, useSelector } from "react-redux";

import { changeExpandedStatus } from "../store/actions/genericActions";
import { AppState } from "../store/definitions";
import { BRAND } from "../brands";
import { containerStyles } from "./styles/EntryPoint.styles";

export const EntryPoint = () => {
    const dispatch = useDispatch();
    const expanded = useSelector((state: AppState) => state.session.expanded);
    // Logo do launcher: dashboard (runtime) tem prioridade; senão o default de build da marca.
    const runtimeLogo = useSelector((state: AppState) => state.config?.launcherLogo);
    const launcherLogo = runtimeLogo ?? BRAND.launcherLogo;

    const renderClosedIcon = () =>
        launcherLogo ? (
            <img
                src={launcherLogo}
                alt="Abrir conversa"
                style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }}
            />
        ) : (
            // Sem logo da marca: ícone de chat genérico (nunca o logo de outra marca).
            <ChatIcon decorative={false} title="Abrir conversa" size="sizeIcon80" />
        );

    return (
        <Box
            as="button"
            data-test="entry-point-button"
            onClick={() => dispatch(changeExpandedStatus({ expanded: !expanded }))}
            {...containerStyles}
        >
            {expanded ? (
                <ChevronDownIcon decorative={false} title="Minimizar conversa" size="sizeIcon80" />
            ) : (
                renderClosedIcon()
            )}
        </Box>
    );
};
